module.exports = __webpack_public_path__ + "img/sld_star2_delta1_transformer_t1_b1.c05a20fe.svg";